/* Always Bright — US-visitor compliance overlay (trademark case LF-288)
 * Blocks shopping for visitors physically in the US on consumer (residential/mobile/ISP) connections.
 * Fails OPEN: any lookup error/timeout/rate-limit => no overlay (never block legit non-US shoppers).
 * The store's market block already prevents US checkout; this is supplementary.
 */
(function () {
  'use strict';

  // --- Provider abstraction: swap endpoint + parse() for a keyed provider later ---
  var PROVIDER = {
    endpoint: 'https://api.ipapi.is/',
    // parse(json) -> { countryCode: string|null, isDatacenter: boolean }
    parse: function (data) {
      var cc =
        (data && data.location && data.location.country_code) || null;
      var dc = !!(data && data.is_datacenter);
      return { countryCode: cc ? String(cc).toUpperCase() : null, isDatacenter: dc };
    }
  };

  var CACHE_KEY = 'ab_geo_block_v1';
  var TIMEOUT_MS = 4000;

  function qp(name) {
    try {
      return new URLSearchParams(window.location.search).get(name);
    } catch (e) {
      return null;
    }
  }

  function showOverlay() {
    if (document.getElementById('ab-us-block-overlay')) return;

    var overlay = document.createElement('div');
    overlay.id = 'ab-us-block-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'ab-us-block-heading');
    overlay.style.cssText = [
      'position:fixed', 'inset:0', 'z-index:999999',
      'display:flex', 'align-items:center', 'justify-content:center',
      'padding:24px', 'box-sizing:border-box',
      'background:rgba(255,255,255,0.82)',
      '-webkit-backdrop-filter:blur(10px)', 'backdrop-filter:blur(10px)',
      'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif'
    ].join(';');

    var card = document.createElement('div');
    card.style.cssText = [
      'max-width:480px', 'width:100%', 'box-sizing:border-box',
      'background:#ffffff', 'border-radius:20px',
      'box-shadow:0 24px 60px rgba(13,71,161,0.18),0 2px 8px rgba(0,0,0,0.06)',
      'padding:40px 32px', 'text-align:center',
      'border-top:6px solid #1565ff'
    ].join(';');

    var badge = document.createElement('div');
    badge.style.cssText = [
      'width:64px', 'height:64px', 'margin:0 auto 24px',
      'border-radius:50%', 'display:flex', 'align-items:center', 'justify-content:center',
      'background:linear-gradient(135deg,#1565ff,#0d47a1)',
      'color:#fff', 'font-size:30px', 'font-weight:700', 'line-height:1'
    ].join(';');
    badge.textContent = '!';
    badge.setAttribute('aria-hidden', 'true');

    var h = document.createElement('h2');
    h.id = 'ab-us-block-heading';
    h.textContent = "We don't ship to the United States";
    h.style.cssText = [
      'margin:0 0 16px', 'font-size:24px', 'line-height:1.25',
      'font-weight:700', 'color:#0d1b2a'
    ].join(';');

    var p = document.createElement('p');
    p.textContent =
      'Unfortunately, Always Bright is currently not available to customers in the United States. We apologize for the inconvenience.';
    p.style.cssText = [
      'margin:0', 'font-size:16px', 'line-height:1.6', 'color:#3a4a5a'
    ].join(';');

    card.appendChild(badge);
    card.appendChild(h);
    card.appendChild(p);
    overlay.appendChild(card);

    var mount = function () {
      // Lock scroll behind the block.
      try {
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
      } catch (e) {}
      document.body.appendChild(overlay);
    };
    if (document.body) mount();
    else document.addEventListener('DOMContentLoaded', mount);
  }

  function decide(result) {
    // result: { countryCode, isDatacenter }
    if (!result || !result.countryCode) return false; // fail open
    if (result.countryCode !== 'US') return false;
    if (result.isDatacenter) return false; // skip datacenter/hosting/VPN
    return true;
  }

  function runLookup() {
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = controller
      ? setTimeout(function () { controller.abort(); }, TIMEOUT_MS)
      : null;

    var opts = { method: 'GET' };
    if (controller) opts.signal = controller.signal;

    fetch(PROVIDER.endpoint, opts)
      .then(function (res) {
        if (timer) clearTimeout(timer);
        if (!res.ok) throw new Error('bad status ' + res.status);
        return res.json();
      })
      .then(function (json) {
        var result = PROVIDER.parse(json);
        try {
          sessionStorage.setItem(CACHE_KEY, JSON.stringify(result));
        } catch (e) {}
        if (decide(result)) showOverlay();
      })
      .catch(function () {
        // Fail open: do nothing on error/timeout/rate-limit. Don't cache failures.
        if (timer) clearTimeout(timer);
      });
  }

  function main() {
    // Manual QA override.
    var test = qp('ab_geo_test');
    if (test === 'US') { showOverlay(); return; }
    if (test === 'off') { return; }

    // Use cached result if present (at most one lookup per session).
    try {
      var cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) {
        var parsed = JSON.parse(cached);
        if (decide(parsed)) showOverlay();
        return;
      }
    } catch (e) {}

    runLookup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', main);
  } else {
    main();
  }
})();
